"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _createSources["default"];
  }
});
var _createSources = _interopRequireDefault(require("./createSources"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }